import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import useB2BTranslation from './hooks/useB2BTranslation';

const ConfirmationModalRequest = ({ open, handleClose, handleConfirm, title, message, confirmParam }) => {
    const { t } = useB2BTranslation('b2b-common');
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    {t('Cancel')}
                </Button>
                <Button onClick={() => handleConfirm(confirmParam)} color="primary" autoFocus>
                    {t('Confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationModalRequest;